'use strict';

var React = require('react/addons');

var TranslationHelper = React.createClass({
  displayName: 'TranslationHelper',

  render: function render() {
    var _props = this.props;
    var component = _props.component;
    var defaultValue = _props.defaultValue;
    var example = _props.example;
    var variables = _props.variables;

    var defaultNode = defaultValue && !component && React.createElement(
      'div',
      null,
      React.createElement(
        'strong',
        null,
        'Default:'
      ),
      React.createElement('br', null),
      defaultValue
    );

    var exampleNode = example && !component && React.createElement(
      'div',
      null,
      React.createElement(
        'strong',
        null,
        'Example:'
      ),
      React.createElement('br', null),
      example
    );

    var variablesNode = variables && !component && React.createElement(
      'div',
      null,
      React.createElement(
        'strong',
        null,
        'Variables:'
      ),
      React.createElement('br', null),
      variables
    );

    return React.createElement(
      'div',
      {
        className: 'helper',
        onClick: this.props.onClick },
      React.createElement(
        'div',
        {
          className: 'helper-window',
          onClick: this._onClick },
        component,
        defaultNode,
        exampleNode,
        variablesNode
      )
    );
  },

  _onClick: function _onClick(evt) {
    evt.stopPropagation();
  }

});

module.exports = TranslationHelper;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/translation-helper.js
 **/